<template>
  <div>
    <highcharts
      :options="chartOptions"
    />
  </div>
</template>
<script>
  import {Chart} from 'highcharts-vue'
  import * as formatters from './../formatters.js'

  export default {
    components: {
      highcharts: Chart
    },
    props: ['type', 'data', 'total'],
    computed: {
      chartOptions(){
        const type = this.type
        let output = {};
        output.credits = {enabled: false};
        output.chart = {type: 'column'};
        output.title = {};
        output.title.style = {color: '#666666'};
        output.legend = {enabled:false};
        output.xAxis = {};
        output.xAxis.type = 'datetime';
        //output.xAxis.units = 'week';
        output.yAxis = {};
        output.yAxis.title = {text: ''};
        output.tooltip = {};
        output.tooltip.useHTML = true;
        output.tooltip.split = false;
        output.plotOptions = {};
        output.plotOptions.column = {};
        output.plotOptions.column.stacking = "normal";
        output.plotOptions.column.dataLabels = {enabled : false};
        output.series = this.data
        output.title.text = formatters.ucFirst(type) +": "+ formatters[type+"Formatter"](this.total)
        output.yAxis.labels = { 
              formatter: function(){ return formatters[type+"Formatter"](this.value)}
        }
        output.tooltip = {
          formatter: formatters[type+"TooltipFormatter"]
        }

        /*switch (this.type){
          case "revenue":
            output.title.text = this.ucFirst(this.type) +": "+ this.currencyFormat(this.total)
            output.yAxis.labels = { 
              formatter: function () {
                return new Intl.NumberFormat('fr-FR', {
                    style: 'currency',
                    currency: "EUR",
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0
                }).format(this.value)
              }
            }
            output.tooltip = {
              formatter: revenueTooltipFormatter
            }
            break
          case "impressions":
            output.title.text = this.ucFirst(this.type) +": "+ this.impressionsFormat(this.total)
            break
        }

        /*
        switch (this.type)
        {
           case "revenue":
                output.yAxis.labels = { 
                  formatter: function () {
                    return curformatter.format(this.value);}
                }
                output.tooltip.formatter = curtooltipformatter;
                output.title.text= 'Revenue: '+curformatter.format(total);
                break;
            case "impressions":
                output.yAxis.labels ={   formatter: function () {return makeFriendly(this.value);}}
                output.tooltip.formatter = ktooltipformatter;
                output.title.text= 'Impressions: '+makeFriendly(total);
                break;
            case "cpm":
                output.yAxis.labels ={   formatter: function () {return cpmformatter.format(this.value);}}
                output.tooltip.formatter = cpmtooltipformatter;
                output.title.text= 'CPM: '+cpmformatter.format(total);
                break;
        }
        */
        return output
      },
      /*
      sum(){
        let sum = 0;
        this.data.forEach((item) =>{
          item.data.forEach((elem) => {
            sum += elem[1]
          })
        })
        return sum
      }
      */
    }
  }
</script>